import React from 'react';
import Layout from '../../components/Layout/Layout';
import HeroSection from '../../components/HeroSection/HeroSection';
import styles from './HeroSectionPage.module.css';

const HeroSectionPage = () => {
  return (
    <Layout width="1440px">
      <div className={styles.heroSectionStack}>
        <HeroSection 
          size="Desktop 1440"
        />
      </div>
    </Layout>
  );
};

export default HeroSectionPage;